export const environment = {
  production: false,
  enableAnalytics: false,
  tenantKey: 'tbds-common',
  firebase: {
    apiKey: 'AIzaSyCP8QGSHUwegPT_tQYHIhdpCTcrVxAnH4o',
    authDomain: 'tbds-common.firebaseapp.com',
    projectId: 'tbds-common',
    storageBucket: 'tbds-common.firebasestorage.app',
    messagingSenderId: '613587217102',
    appId: '1:613587217102:web:38e443b0a1259867d77e9f',
    measurementId: 'G-HKN4XTLRYW'
  },
  // Dev environment points to tbds-common tenant API.
  apiUrl: 'https://europe-west1-tbds-common.cloudfunctions.net/api/v1',
  googleMapsApiKey: 'AIzaSyCYByEecYG0DQgBTkWI4qTs8OE5Pnrb58k', // Required for address autocomplete - ensure Places API is enabled in Google Cloud Console
  inactivityTimeoutMs: 60 * 60 * 1000,
  clarity: {
    enabled: false,
    projectId: 'wxkhsrsotb'
  }
};



